import React, { Component } from 'react'
import { assetUrl } from '../../../config';
import AutoVideo from '../../AutoVideo';
import { withT } from '../../../i18n';
class Wavestep extends Component {
    server_path = window.src_path;

    loadInitJs() {
        /* var item_name = this.pr */
        /* console.log(item_name); */
    }
    componentDidMount() {
        this.loadInitJs();
    }
    render() {
        const { t } = this.props;
        return (
            <>
                <div className="portfolio__main">
                    <div className="wrapper">
                        <div className="portfolio__inner">
                            <div className="left__panel">
                                <div className="image_div">
                                    <AutoVideo src={assetUrl('collection/topslide/Wavestep.mp4')} poster={assetUrl('collection/topslide/Wavestep.jpg')} aria-label="Wavestep by Neurocolor"></AutoVideo>
                                </div>
                            </div>
                            <div className="right__panel">
                                <h2 className="heading">Wavestep</h2>

                                <h2 className="artist_name"><span>{t('work.by')} </span> Neurocolor </h2>
                                <div className="desc">
                                    <p>Abstract Motion Expressionism</p>
                                </div>

                                <a href="https://opensea.io/assets/0xb932a70a57673d89f4acffbe830e8ed7f75fb9e0/18244" className="css_btn"><span>{t('work.viewArtwork')}</span></a>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default withT(Wavestep);
